




























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Consulta from "../../models/consulta.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import BTableConfigDetailing from "../../core/BTableConfig/BTableConfigDetailing";
import Persona from "@/models/persona/persona.model";
import Usuario from "@/models/usuarios/usuario.model";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
@Component
export default class PerfilCiudadanoListaConsultas extends GenericBTable<
  Consulta
> {
  @Prop() readonly personaId!: number;
  @Prop() public title!: string;
  @Prop() public hideHeader!: string;
  tipoId: any = 0;
  setupTable() {
    this.tableConfig.controller = "Consulta";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    this.tableConfig.activeActions = false;
    this.tableConfig.loadOnMount = !!this.personaId;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.include = "TipoServicio|Persona|Usuario";
    this.formatColumns();
  }
  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("personaId", "number"));
    this.$emit("render", props);
    this.setupTable();
  }

  formatColumns() {
    let tipoServicioNombre = new BTableColumn(
      "tipoServicioNombre",
      "Tipo de servicio",
      false
    );
    let persona = new BTableColumn("personaIdentifier", "Persona", false);
    persona.customTemplate = true;
    persona.templateSlot = "persona";
    let usuario = new BTableColumn("usuarioId", "Representante");
    usuario.customTemplate = true;
    usuario.templateSlot = "usuario";
    let fechaApertura = new BTableColumn("fechaApertura", "Fecha de apertura");
    fechaApertura.type = BTableColumnType.DateTime;
    let fechaCierre = new BTableColumn("fechaCierre", "Fecha de cierre");
    fechaCierre.type = BTableColumnType.DateTime;
    this.tableConfig.insertColumns(
      tipoServicioNombre,
      persona,
      //usuario,
      fechaApertura,
      fechaCierre
    );
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.detailed = true;
    //this.tableConfig.customButtomLeftTemplate = true;
  }
  getPersona(id: number, nombre: string, cedula: string, foto: string) {
    let persona = new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }

  getUsuario(row: any) {
    let usuario = new Usuario();
    usuario.id = row.usuarioId;
    usuario.imagenPerfil = row.usuarioImagenPerfil;
    usuario.userName = row.usuarioUserName;
    usuario.email = row.usuarioUserEmail;
    return usuario;
  }

  @Watch("personaId", { immediate: true })
  onPersonaIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.search();
  }
 
  searchText = "";
  getWhereParams() {
    let result = [];
    if (this.personaId) 
      result.push(`personaId="${this.personaId}"`);
    if (this.tipoId) 
      result.push(`tipoServicioId="${this.tipoId}"`);
    return result.join("&&");
  }
  search() {
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
